import { Outlet } from 'react-router-dom'
import { Sidebar } from '@/components/common/layout/sidebar/sidebar'

export function MainLayout() {
  return (
    <div className="h-screen flex flex-col">
      <div className="flex flex-1 overflow-hidden">
        <Sidebar />
        <main className="flex-1 overflow-auto">
          <div className="container mx-auto p-6">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  )
}
